<div class="full-width full-height" style="overflow: auto;" [froalaView]="model"></div>
